import { ResponsivePage } from 'modules/layout/components/ResponsivePage'
import PayrollPaywallGuard from 'modules/payroll_bundle/pages/PayrollPaywallGuard'
import LinkStatus from 'modules/payroll_integrations_datev_api/components/IntegrationLinkStatus'

const Settings = () => {
  return (
    <PayrollPaywallGuard>
      <ResponsivePage.Body>
        <LinkStatus />
      </ResponsivePage.Body>
    </PayrollPaywallGuard>
  )
}

export default Settings
